import React, { useState } from "react";
import MainLayout from "../../components/layout/MainLayout";
import { graphql } from "gatsby";
import { PageComponents } from "./PageComponents";
import { PageTemplateProps } from "./PageTypes";
import { PageMetadataContext } from "./PageContext";
import { getSeoProps } from "./PageUtils";
import { useUpdatePersonalization } from "../../lib/usePersonalization";
import { PageBreadcrumbs } from "./PageBreadcrumbs";

const PageTemplate: React.FC<PageTemplateProps> = ({
  data,
  pageContext,
  location,
  ...props
}) => {
  const elements = data?.kontentItemContentPage?.elements || {};
  const systemData = data?.kontentItemContentPage?.system || {};
  const pageData =
    data?.kontentItemPage?.elements || data?.kontentItemHomepage?.elements;
  const [pageMetadata, setPageMetadata] = useState({
    slug: pageData?.url?.value || "",
    location: location,
    breadcrumbs: pageData?.breadcrumbs || [],
    title: pageData?.title?.value || "",
  });
  const seo = getSeoProps({ pageData, elements, systemData });

  const hideBreadcrumbs =
    pageData?.hide_breadcrumbs?.value[0]?.codename === "yes" ? true : false;

  useUpdatePersonalization(pageData?.personalization);

  return (
    <MainLayout siteFrame={pageData?.site_frame} seo={seo} location={location}>
      <PageMetadataContext.Provider value={pageMetadata}>
        {!hideBreadcrumbs &&
          pageData?.breadcrumbs &&
          pageData?.breadcrumbs.length > 1 && (
            <PageBreadcrumbs breadcrumbs={pageData?.breadcrumbs} />
          )}
        <PageComponents
          systemId={data?.kontentItemContentPage?.system?.id}
          elements={elements}
        />
      </PageMetadataContext.Provider>
    </MainLayout>
  );
};

export default PageTemplate;

export const pageQuery = graphql`
  query PageById($pageId: String!, $contentId: String!) {
    kontentItemHomepage(id: { eq: $pageId }) {
      elements {
        title {
          value
        }
        site_frame {
          ...kontentSiteFrame
        }
      }
    }
    kontentItemPage(id: { eq: $pageId }) {
      elements {
        breadcrumbs
        hide_breadcrumbs {
          value {
            codename
          }
        }
        url {
          url
          value
        }
        title {
          value
        }
        display_publish_date {
          value
        }
        site_frame {
          ...kontentSiteFrame
        }
        personalization {
          value {
            codename
          }
        }
      }
    }
    kontentItemContentPage(id: { eq: $contentId }) {
      system {
        id
        codename
        last_modified
      }
      elements {
        page_metadata__page_description {
          value
        }
        page_metadata__canonical_url {
          value
        }
        page_metadata__robots_follow {
          value {
            codename
          }
        }
        page_metadata__robots_index {
          value {
            codename
          }
        }
        page_metadata__sitemap_include {
          value {
            codename
          }
        }
        page_metadata__social_share_description {
          value
        }
        page_metadata__social_share_image {
          value {
            ... on kontent_item_image {
              elements {
                image {
                  value {
                    url
                    width
                    height
                    description
                  }
                }
              }
            }
          }
        }
        page_metadata__social_share_title {
          value
        }
        page_metadata__twitter_card_type {
          value {
            codename
          }
        }
        page_metadata__schema_markup {
          ...schemaMarkup
        }
        content_components__content {
          ...kontentRichText
        }
      }
    }
  }
`;
